'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrialId = undefined;

var _getAvailableTrials = require('self-service-api/api/getAvailableTrials');

var _validators = require('self-service-api/core/validators');

var _Trials = require('self-service-api/constants/Trials');

var _trialIdAdapter = require('self-service-api/adapters/trialIdAdapter');

var _trialIdAdapter2 = _interopRequireDefault(_trialIdAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTrialId = exports.getTrialId = function getTrialId(upgradeProduct) {
  (0, _validators.validateUpgradeProduct)(upgradeProduct);

  var merchandiseId = _Trials.upgradeProductToMerchIds[upgradeProduct];
  if (!merchandiseId) return null;

  return (0, _getAvailableTrials.getAvailableTrials)().then(function (availableTrials) {
    return (0, _trialIdAdapter2.default)(availableTrials, merchandiseId);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/api/getTrialId.js
// module id = 451
// module chunks = 3 4 5